import { SafeUrl, DomSanitizer } from "@angular/platform-browser";
import { Component, OnInit, Inject, OnDestroy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA, MatDialogModule } from "@angular/material/dialog";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatIconModule } from "@angular/material/icon";
import { TranslatePipe } from "@ngx-translate/core";

interface LoginModalData {
  login_url: string;
  isLoggedIn: boolean;
}

@Component({
  standalone: true,
  imports: [MatDialogModule, MatIconModule, MatToolbarModule, TranslatePipe],
  selector: "o-login-modal",
  templateUrl: "./login-modal.component.html",
  styleUrls: ["./login-modal.component.scss"]
})
export class LoginModalComponent implements OnInit, OnDestroy {
  public isLoggedIn = false;
  public login_url: SafeUrl;

  private authRequestEndCallbackBind: () => {};

  constructor(
    private dialog: MatDialogRef<LoginModalComponent>,
    private sanitizer: DomSanitizer,
    @Inject(MAT_DIALOG_DATA) private data: LoginModalData
  ) {}

  ngOnInit() {
    this.login_url = this.sanitizer.bypassSecurityTrustResourceUrl(this.data.login_url);
    this.isLoggedIn = this.data.isLoggedIn;
    this.authRequestEndCallbackBind = this.authRequestEndCallback.bind(this);

    addEventListener("authRequestEnd", this.authRequestEndCallbackBind);
  }

  ngOnDestroy() {
    removeEventListener("authRequestEnd", this.authRequestEndCallbackBind);
  }

  public close(): void {
    this.dialog.close();
  }

  private authRequestEndCallback(): void {
    this.close();
  }
}
